import React from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {observer} from "mobx-react";
import useFeature from "../../../useFeature";
import {PRODUCT_DETAIL_PATH,} from "../../../routes";
import {useApplication} from "../../../ApplicationProvider";
import {MarketplaceSearchFeature} from "./MarketplaceSearchFeature";
import AddProductToCartButton from "../detail/AddProductToCartButton";
import {SelectDeliveryPointFeature} from "../detail/SelectDeliveryPointFeature";

const MarketplaceSearchScreen = () => {
    const {articleOrCategoryName} = useParams()
    const application = useApplication()
    const feature = useFeature(() => new MarketplaceSearchFeature(application, articleOrCategoryName),
        [articleOrCategoryName]);
    const navigator = useNavigate();
    const deliverySiteFeature = useFeature(() => new SelectDeliveryPointFeature(application));

    const isFeatureReady = () => {
        return feature && feature.loaded;
    }

    return (isFeatureReady() &&
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="our-selections" style={{ fontFamily: 'ArcherSmbd, sans-serif' , fontWeight: 'bold', fontSize:'30px', textAlign: 'left'}}>
                            Se encontraron {feature.articles().length} resultado{feature.articles().length !== 1 ? 's' : ''} para "{articleOrCategoryName}"
                        </div>
                    </div>
                    {feature.articles().map(item => (
                        <div className="col-xs-12 col-sm-6 col-md-4" key={item.Id}>
                            <div className="product-item relative">
                                <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`} className="img-box">
                                    <img src={item.Producto.Archivo} className="img-responsive img-producto-categoria"
                                         alt="Foto de Categoría"/>
                                </Link>
                                <div className="footer-product">
                                    <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`}
                                          className="h5 title-product show">{item.Producto.NombreFantasia}</Link>
                                    {feature.canAddProduct() &&
                                        <AddProductToCartButton
                                            productId={item.Id}
                                            application={application}
                                            navigator={navigator}
                                            deliverySiteFeature={deliverySiteFeature}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <hr className="visible-xs divider-line footer-line"/>
        </div>
    );
};

export default observer(MarketplaceSearchScreen);
